

/* import React, { useEffect, useState } from "react";
import LiveOrders from "./components/liveOrders";
// import AuthGate from "./components/AuthGate";
import AuthGate from "./authGate";
import { initDB } from "./db";

const App = () => {
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    initDB();

    const token = localStorage.getItem("auth_token");
    if (token) {
      setIsAuth(true);
    }
  }, []);

  return (
    <>
      {isAuth ? (
        <LiveOrders />
      ) : (
        <AuthGate onSuccess={() => setIsAuth(true)} />
      )}
    </>
  );
};

export default App; */

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
// import EnterToken from "./EnterToken";
import AuthGate from "./authGate";
import LiveOrders from "./components/liveOrders";
import { initDB } from "./db";
// import LiveOrders from "./LiveOrders";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/default.css";
import "./alertyfy-custom.css";

function App() {
  const [token, setToken] = useState(null);
  // const token = localStorage.getItem("auth_token");
  // console.log(token)
  useEffect(() => {
    async function initDatabase() {
      const status = await initDB();
      // console.log("db status " + status);
    }
    initDatabase();
    setToken(localStorage.getItem("auth_token"));
    // const token = localStorage.getItem("auth_token");
    /* if (token) {
      setIsAuth(true);
    } */
  }, []);
  return (
    // <BrowserRouter>
      <Routes>
        <Route path="/" element={!token ? <AuthGate /> : <Navigate to="/dashboard" replace />} />
        <Route
          path="/dashboard"
          element={token ? <LiveOrders /> : <Navigate to="/" replace />}
        />
      </Routes>
    // </BrowserRouter>
  );
}
export default App;